import styled from "@emotion/styled";

const TextButton = styled.div`
  cursor: pointer;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #2934d0;
  text-align: center;
  padding-top: 15px;
`;

export default TextButton;
